import { ComponentType, SVGProps } from 'react';

import Gift from '@/components/SvgIcons/Gift';
import Learn from '@/components/SvgIcons/Learn';
import PC from '@/components/SvgIcons/PC';
import Partner from '@/components/SvgIcons/Partner';
import colors from '@/styles/themes/colors';

interface SvgIconProps {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}

export interface CareerOffer {
  id: string;
  icon: ComponentType<SvgIconProps>;
  titleKey: string;
  descriptionKey: string;
  color: string;
  bgColor: string;
  colorVariant: 'blue' | 'green' | 'orange' | 'pink';
}

export const careerOffers: CareerOffer[] = [
  {
    id: 'employment',
    icon: Partner,
    titleKey: 'offers.employment.title',
    descriptionKey: 'offers.employment.description',
    color: colors.blue500,
    bgColor: colors.blue950,
    colorVariant: 'blue',
  },
  {
    id: 'learning',
    icon: Learn,
    titleKey: 'offers.learning.title',
    descriptionKey: 'offers.learning.description',
    color: colors.green500,
    bgColor: colors.green950,
    colorVariant: 'green',
  },
  {
    id: 'equipment',
    icon: PC,
    titleKey: 'offers.equipment.title',
    descriptionKey: 'offers.equipment.description',
    color: colors.orange500,
    bgColor: colors.orange950,
    colorVariant: 'orange',
  },
  {
    id: 'bonuses',
    icon: Gift,
    titleKey: 'offers.bonuses.title',
    descriptionKey: 'offers.bonuses.description',
    color: colors.pink500,
    bgColor: colors.pink950,
    colorVariant: 'pink',
  },
];
